import Chart from 'chart.js';
import { openPopup } from '@/popups';

let initiatedChart = false;

export function eventResult() {
  const $openPopup = $('.popup-open-interview-result');
  if (!$openPopup && $openPopup.length === 0) return;

  $(document).on('click', '.popup-open-interview-result', (e) => {
    e.preventDefault();
    let target;
    const href = $(e.currentTarget).attr('href');
    if (!href) {
      target = $(e.currentTarget).data('popup');
    } else {
      target = href;
    }

    if (!target) return;

    const $popup = $(target);

    openPopup($popup);

    if (!initiatedChart) initChart();
  });
}

function initChart() {
  const $chart = $('#event-interview-result-chart');
  if (!$chart || $chart.length === 0) return;
  let labels = $chart.data('labels');
  let data = $chart.data('value');
  let maxCount = 0;
  let step = 4;

  labels = labels.split(',');
  data = data.split(',');

  data.map((val) => {
    if (maxCount < +val) maxCount = +val;
  });

  if (maxCount < step) {
    maxCount = step;
    step = 1;
  } else {
    step = Math.round(maxCount / 4);
  }

  maxCount = (maxCount % step) + step ? step * 4 + step : maxCount;

  let fontSizeY = 18;
  let fontSizeX = 20;
  let paddingY = 23;
  let paddingX = 28;

  if ($(window).width() < 768) {
    fontSizeY = 12;
    fontSizeX = 14;
    paddingY = 14;
    paddingX = 19;

    $chart.attr('height', 300);
  }

  const chartData = {
    labels,
    datasets: [
      {
        data,
        maxBarThickness: 92,
        backgroundColor: ['#4bcd9c', '#dbe0e3'],
      },
    ],
  };

  const options = {
    scales: {
      xAxes: [
        {
          gridLines: {
            display: false,
          },
          ticks: {
            color: '#333333',
            padding: paddingX,
            fontFamily: '"Roboto", sans-serif',
            fontSize: fontSizeX,
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            min: 0,
            max: maxCount,
            stepSize: step,
            color: '#333333',
            padding: paddingY,
            fontFamily: '"Roboto", sans-serif',
            fontSize: fontSizeY,
          },
          gridLines: {
            drawBorder: false,
            color: '#c4c4c4',
          },
        },
      ],
    },
    legend: {
      display: false,
    },
    tooltips: {
      enabled: false,
    },
  };

  const chart = new Chart($chart, {
    maintainAspectRatio: true,
    type: 'bar',
    data: chartData,
    options,
  });

  initiatedChart = true;
}
